export function setAll(state, { all }) {
  state.all = all;
}

export function setAllTopics(state, { all }) {
  state.allTopics = all;
}

export function setCurrentTopic(state, { current }) {
  state.currentTopic = current;
}
